import React, { Component } from 'react';
import ParameterErrors from '../errors/ParameterErrors';
import ParameterError from '../errors/ParameterError';
import TabPanel_Panel from './tabs/TabPanel_Panel';
import TabPanel_Tab from './tabs/TabPanel_Tab';
import HashSource from '../core/HashSource';
import './TabPanel.css';
const{throwNotProvided}=ParameterErrors;
export default class TabPanel extends Component {
	constructor(props){
		super(props)
		this._element = React.createRef();
		const {defaultActiveTabIndex, onSetActive}= props;
		this.setActive= this.setActive.bind(this);
		this._callbackSetActive= onSetActive;
		const panels = [];
		let index=0;
		this._defaultActiveTabIndex = defaultActiveTabIndex;
		this.props.children.forEach(child=>{
			const panelRef=React.createRef();
			const active = index===defaultActiveTabIndex;
			const childTabKey = child?.props?.tabKey;
			const tabKey = childTabKey!==undefined&&childTabKey!==null?childTabKey:HashSource.next();
			const panel = (<TabPanel_Panel ref={panelRef} active={active} key={tabKey}>{child}</TabPanel_Panel>);
			panels.push(panel);
			index++;
		});
		this.state={tabs:[], panels:panels}
	}
	setActive(tabKey){
		this.state.tabs.forEach(tab=>{
			const tabElement = tab.ref.current;
			const active = tab.key===tabKey;
			tabElement.active= active;
		});
		this.state.panels.forEach(panel=>{
			const panelElement = panel.ref.current;
			const active = panel.key===tabKey;
			panelElement.active= active;
		});
		this._callbackSetActive&&this._callbackSetActive(tabKey);
	}
	componentDidMount(){
		let index=0;
		const tabs =[];
		this.state.panels.forEach(panel=>{
			const tabRef = React.createRef();
			const active = index===this._defaultActiveTabIndex;
			const tab = (<TabPanel_Tab panel={panel} ref={tabRef} tabInfo={panel.ref.current.tabInfo}
			active={active} setActive={()=>this.setActive(panel.key)} key={panel.key}></TabPanel_Tab>);
			tabs.push(tab);
			index++;
		});
		this.setState({tabs:tabs});
		
	}
	render() {
		return (<div className="tab-panel" ref={this._element}>
			<div className="tabs">{this.state.tabs}</div>
			<div className="panels">{this.state.panels}</div>
		</div>)
	}
}
